import { useEffect, useState, useRef } from "react";
import { getRroomPropertyAction, propertySeletor } from "@store/slices/propertySlice";
import { useDispatch, useSelector } from "react-redux";
import { authenticationSeletor } from "@store/slices/authenticationSlice";
import Moment from "react-moment";
import Services from "@api/services";
import { toast } from "react-toastify";
import moment from "moment";
import { baseImgUrl } from "@api/client/api";
import ReactGA from "react-ga4";
import axios from "axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import { IoLocationOutline } from '@assets/Icons';
import { Helmet } from "react-helmet-async";

const Bookingconfirm = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const data = useParams();

    const [hoterData, setHotelData] = useState({});
    const [propertyList, setPropertyList] = useState([]);
    const { rRoomProperty } = useSelector(propertySeletor);
    const { userDetail } = useSelector(authenticationSeletor);

    const getBooking = async (id) => {
        try {
            const res = await Services.property.getBookingById(id);
            if (res.status === 200) {
                if (res.data.data.bookingStatus == 1) {
                } else if (res.data.data.bookingStatus == 7) {
                    toast.error("Room Booking Failed*", {
                        autoClose: 2000,
                        pauseOnHover: true,
                    });
                } else if (res.data.data.bookingStatus == 8) {
                    toast.warning("Your Transaction In Process*", {
                        autoClose: 2000,
                        pauseOnHover: true,
                    });
                }
                setHotelData(res?.data?.data);
                const reqData = {
                    countryCode: "+91",
                    phoneNumber: res.data.data.User.mobile,
                    callbackData: "some text here",
                    type: "Template",
                    template: {
                        name: "room_reservation_confirmation",
                        languageCode: "en",
                        bodyValues: [
                            res.data.data.otherPersonName ??
                            res.data.data.User.name ??
                            "Guest",
                            res.data.data.PropertyMaster.name,
                            moment(res.data.data.createdAt).format("DD-MM-YYYY HH:MM A"),
                        ],
                        buttonValues: {
                            1: ["room Booking"],
                        },
                    },
                };
                const data = await fetch(`https://api.interakt.ai/v1/public/message/`, {
                    method: "post",
                    headers: {
                        Authorization: `Basic T1VZU0lGLXNyZzVXWENSengzdTdGSTdXWlNjbzBvWGJLSEQ4Y0VubWtXZzo=`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(reqData),
                });
            } else {
                navigate("/");
            }
        } catch (error) { }
    };

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "booking_confirm" });
        dispatch(getRroomPropertyAction());
    }, []);

    useEffect(() => {
        if (data?.id) {
            getBooking(data?.id);
        } else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        setPropertyList(rRoomProperty);
    }, [rRoomProperty]);

    const addressRenderer = (id, datatype) => {
        const getData = propertyList.find((innerdata) => {
            if (innerdata.id === id) {
                return innerdata.city;
            }
        });
        if (getData) {
            return getData[datatype];
        }
    };


    const bookHandler = async () => {
        try {
            let paymentType = 'Full'
            const bookRes = await Services.property.updateBookingModeStatus(
                hoterData?.id,
                {
                    status: 1,
                    paymentMode: 1,
                    paymentAmount: paymentType
                }
            );

            if (bookRes.status == 200) {
                const res = await Services.property.paymentGateway(hoterData?.id, paymentType)
                openRazorpay(res?.data?.data?.order_id, res?.data?.data?.amount, paymentType, hoterData?.id)
            }
        } catch (error) { }
    };

    const openRazorpay = async (orderId, amount, paymentType, bookingId) => {
        let db_amount = amount / 100
        const options = {
            key: 'rzp_live_Eqmw0XU2XIG31l',
            amount: amount,
            currency: "INR",
            name: "RROOMS",
            description: "RRooms Hotel Booking Payment",
            image: "https://rrooms.in/logo.webp",
            order_id: orderId,
            handler: async function (response) {
                let newRes = await axios.post(`https://rrooms.in/rrooms/api/rrooms-property/razorpay-status-update?booking_id=${bookingId}&paymentType=${paymentType}&paidAmount=${db_amount}&userId=${userDetail?.id}&dueAmount=${paymentType == 'Full ' ? 0 : hoterData?.dueAmount - db_amount} `, {
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                });
                // alert("Payment successful and verified!");
                if (newRes.status === 200) {
                    navigate(`/booking-confirm/${hoterData?.id}`);
                }
            },
            prefill: {
                name: userDetail?.name,
                email: userDetail?.email,
                contact: userDetail?.mobile
            },
            theme: {
                color: "#fb961b"
            },
            modal: {
                ondismiss: function () {
                    navigate(`/booking-confirm/${hoterData?.id}`);
                }
            }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };


    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://rrooms.in" />
            </Helmet>
            <div className='bg-gray border-bottom booking-confirm-head pv-3'>
                <div className='container'>
                    {
                        hoterData.bookingStatus == 8 ? (
                            <div className='row justify-content-between align-items-center'>
                                <div className='col-lg-6'>
                                    <h2 className='text-danger pb-1'>Your Transaction In Process, It may be confirmed or Failed</h2>
                                    <p className="fs-6 text-light">
                                        You will soon receive an email for Booking Status on{" "}
                                        <a href={`mailto:${userDetail.email}`} className="text-secondary"> {userDetail.email}</a>
                                    </p>
                                </div>
                                <div className='col-lg-6 text-right'>
                                    <button
                                        type='button'
                                        className='btn btn-secondary btn-sm'
                                        onClick={() =>
                                            navigate(`/hotel-details/${hoterData?.propertyId}`)
                                        }>
                                        Go to your Booking
                                    </button>
                                </div>
                            </div>
                        ) : hoterData.bookingStatus == 7 ? (
                            <div className='row justify-content-between align-items-center'>
                                <div className='col-lg-6'>
                                    <h2 className='text-danger pb-1'>Your booking has been Failed</h2>
                                </div>
                                <div className='col-lg-6 text-right'>
                                    <button
                                        type='button'
                                        className='btn btn-secondary btn-sm'
                                        onClick={() =>
                                            navigate(`/hotel-details/${hoterData?.propertyId}`)
                                        }>
                                        Go to your Booking
                                    </button>
                                </div>
                            </div>
                        ) :
                            <div className='row justify-content-between align-items-center'>
                                <div className='col-lg-6'>
                                    <h2 className='text-success pb-1'>Great! Your stay is confirmed.</h2>
                                    <p className="fs-6 text-light">
                                        You will soon receive an email confirmation on
                                        <a href={`mailto:${userDetail.email}`} className="text-secondary"> {userDetail.email}</a>
                                    </p>
                                </div>
                                <div className='col-lg-6 text-right'>
                                    <button
                                        type='button'
                                        className='btn btn-secondary btn-sm'
                                        onClick={() => navigate(`/user-profile`)}>
                                        Go to your Booking
                                    </button>
                                </div>
                            </div>
                    }
                </div>
            </div>
            <div className="booking-confirm-main">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="primary-panel p-0">
                                <div className="bg-secondary-light border-bottom border-secondary d-flex align-items-center justify-content-between ph-3 pv-2">
                                    {
                                        hoterData?.bookingCode ? (
                                            <div className="left w-40">
                                                <h3 className='pb-1'>
                                                    {hoterData?.PropertyMaster?.name}
                                                </h3>
                                                <h4 className='text-uppercase text-light'>#Booking ID - {hoterData?.bookingCode}</h4>
                                            </div>
                                        ) : null
                                    }
                                    {
                                        hoterData?.bookingType == "Hourly" &&
                                        <div className="w-20 text-center">
                                            <span className="btn-mat btn-mat-secondary bg-white">{hoterData?.bookingType}</span>
                                        </div>
                                    }
                                    <div className="right w-40 text-right">
                                        <h5 className='fw-semibold pb-1'>Booked by {userDetail.name} on</h5>
                                        <h5 className="fw-semibold text-light">
                                            <Moment format="MMMM Do YYYY, h:mm:ss a">
                                                {hoterData?.createdAt}
                                            </Moment>
                                        </h5>
                                    </div>
                                </div>
                                <div className="p-3">
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <h5 className="fw-semibold mb-2">
                                                <span className="text-light">Landmark : </span>
                                                <span>{hoterData?.PropertyMaster?.locality}</span>
                                            </h5>
                                            <h5 className="fw-semibold mb-2">
                                                <span className="text-light">Checkin date :  </span>
                                                <span>
                                                    {moment(hoterData?.fromDate).format('DD-MM-YYYY')}
                                                    {
                                                        hoterData?.bookingType == "Hourly" ? ` at (${hoterData?.bookingHours?.split(" to ")[0]})` : ('12:00 PM')
                                                    }
                                                </span>
                                            </h5>
                                            <h5 className="fw-semibold mb-2">
                                                <span className="text-light">Checkout date :  </span>
                                                <span>
                                                    {moment(hoterData?.toDate).format('DD-MM-YYYY')}
                                                    {
                                                        hoterData?.bookingType == "Hourly" ? ` at (${hoterData?.bookingHours?.split(" to ")[1]})` : ('11:00 AM')
                                                    }
                                                </span>
                                            </h5>
                                            <h5 className="fw-semibold mb-2">
                                                <span className="text-light">Adult : </span>
                                                <span>{hoterData?.adults}</span>
                                            </h5>
                                            <h5 className="fw-semibold mb-2">
                                                <span className="text-light">Child : </span>
                                                <span>{hoterData?.children}</span>
                                            </h5>
                                            <h5 className="fw-semibold mb-2">
                                                <span className="text-light">No. of Rooms : </span>
                                                <span>{hoterData?.noOfRooms}</span>
                                            </h5>
                                            {
                                                hoterData?.bookingType == "Hourly" && (
                                                    <>
                                                        <h5 className="fw-semibold mb-2">
                                                            <span className="text-light">Booking Slot : </span>
                                                            <span>{hoterData?.bookingSlot}s</span>
                                                        </h5>
                                                        {/* <h5 className="fw-semibold">
                                                            <span className="text-light">Checkin Time : </span>
                                                            <span></span>
                                                        </h5> */}
                                                    </>
                                                )
                                            }
                                            <div className="mt-4">
                                                <button type="button" className="btn btn-secondary btn-sm" onClick={bookHandler}>Pay Now</button>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            {hoterData?.PropertyMaster?.PropertyImages.length ? (
                                                <img
                                                    src={
                                                        hoterData?.PropertyMaster?.PropertyImages
                                                            ? `${baseImgUrl}${hoterData?.PropertyMaster?.PropertyImages[0].image}`
                                                            : ''
                                                    }
                                                    className="rounded-1"
                                                    alt=""
                                                />
                                            ) : (
                                                <img alt="" src={''} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="border-bottom"></div>
                                <div className='p-3'>
                                    <h4>Hotel direction</h4>
                                    <p className='v-center text-secondary fs-6  pt-1'>
                                        <IoLocationOutline size={18} className='mr-1' />
                                        {hoterData?.PropertyMaster?.address}
                                    </p>
                                    <div className='rounded-2 border overflow-hidden mt-2'>
                                        <iframe
                                            width="100%"
                                            style={{ border: 0, height: '200px' }}
                                            loading="lazy"
                                            allowFullScreen
                                            src={`https://www.google.com/maps?q=${hoterData?.PropertyMaster?.latitude},${hoterData?.PropertyMaster?.longitude}&output=embed`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='primary-panel p-0'>
                                <div className='bg-primary-light border-bottom border-primary p-3'>
                                    <h4>Thinks to know</h4>
                                </div>
                                <div className='border-bottom p-2'>
                                    <h6 className='text-light fw-semibold pb-1'>Somthing not right chat with us for help</h6>
                                    <h6 className='text-secondary'>Need help?</h6>
                                </div>
                                <div className='p-2'>
                                    <h6 className='text-light fw-semibold pb-1'>RRooms Term and Condition</h6>
                                    <h6 className='text-secondary'>Read more</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Bookingconfirm;